import React from "react";
import { toast } from "react-toastify";
import { quotationApi } from "api/quotations";
import { DialogRoot } from "components/ui/dialog";
import {
  DialogActionTrigger,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@chakra-ui/react";
import { Button } from "components/ui/button";

const DeleteOrder = ({ id, refetch }) => {
  const handleDelete = async () => {
    const res = await quotationApi.deleteContractor(id);
    if (res.error) {
      toast.error(res.error);
    } else {
      toast.success("تم حذف الطلب بنجاح");
      if (refetch) {
        refetch();
      }
    }
  };

  return (
    <DialogRoot dir="rtl">
      <DialogTrigger asChild>
        <button className="rounded-full bg-red-700 px-6 py-1 text-white transition-all hover:bg-red-900">
          حذف
        </button>
      </DialogTrigger>
      <DialogContent className="fixed top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white text-gray-700 end-1/2 dark:bg-navy-800 dark:text-white">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">تأكيد الحذف</DialogTitle>
        </DialogHeader>
        <DialogBody>هل أنت متأكد من حذف هذا الطلب؟</DialogBody>
        <DialogFooter>
          <Button
            onClick={handleDelete}
            variant="outline"
            className="text-red-400"
          >
            <span>حذف</span>
          </Button>
          <DialogActionTrigger asChild>
            <Button variant="outline">
              <span>إلغاء</span>
            </Button>
          </DialogActionTrigger>
        </DialogFooter>
        <DialogCloseTrigger />
      </DialogContent>
    </DialogRoot>
  );
};

export default DeleteOrder;
